import {useTranslation} from 'react-i18next';
import {cn} from '@chekinapp/ui';

export type CaptureWaitNoteProps = {
  className?: string;
};

export function CaptureWaitNote({className}: CaptureWaitNoteProps) {
  const {t} = useTranslation('identity-verification');

  return (
    <p
      className={cn(
        'm-0 flex items-center justify-center gap-1.5 text-center text-[13px] font-medium text-[var(--chekin-color-gray-1)]',
        className,
      )}
    >
      {t('takes_a_few_seconds_dont_close')}
    </p>
  );
}
